export const SUPPORTED_PHOTO_EXTENSIONS = [
  'jpg',
  'jpeg',
  'jfif',
  'png',
  'webp',
  'bmp',
  'gif',
  'tif',
  'tiff',
  'heic',
  'heif',
] as const;

const SUPPORTED_PHOTO_MIME_TYPES = new Set([
  'image/jpeg',
  'image/jpg',
  'image/pjpeg',
  'image/jfif',
  'image/png',
  'image/webp',
  'image/bmp',
  'image/gif',
  'image/tiff',
  'image/heic',
  'image/heif',
]);

export const SUPPORTED_PHOTO_ACCEPT = [
  ...SUPPORTED_PHOTO_EXTENSIONS.map((extension) => `.${extension}`),
  ...Array.from(SUPPORTED_PHOTO_MIME_TYPES),
].join(',');

export function getFileExtension(fileName: string | null | undefined): string {
  const match = String(fileName || '').toLowerCase().match(/\.([^.?#/]+)(?:[?#].*)?$/);
  return match?.[1] || '';
}

export function isSupportedPhotoFile(file: File): boolean {
  const mimeType = String(file.type || '').toLowerCase();
  if (mimeType && SUPPORTED_PHOTO_MIME_TYPES.has(mimeType)) {
    return true;
  }

  return SUPPORTED_PHOTO_EXTENSIONS.includes(getFileExtension(file.name) as any);
}
